module.exports = __webpack_public_path__ + "static/media/orangeblob.1fa7e520.svg";